<svg style="background:var(--anatomy-gray-100); padding: 5px 0" height="142" viewBox="0 0 142 142">
  <defs>
    <linearGradient id="linear-gradient" x2="1" y2="1" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--anatomy-gray-300)"/>
      <stop offset="1" stop-color="var(--anatomy-gray-500)"/>
    </linearGradient>
  </defs>
  <g id="Area" fill="url(#linear-gradient)" stroke="var(--anatomy-gray-900)" stroke-opacity="0.1" stroke-width="1">
    <rect width="142" height="142" rx="4" stroke="none"/>
    <rect x="0.5" y="0.5" width="141" height="141" rx="3.5" fill="none"/>
  </g>
  <g id="Handle">
    <rect id="Placement_Area-2" data-name="Placement Area" width="16" height="16" transform="translate(100 47)" fill="red" opacity="0"/>
    <g id="Handle_Ring" data-name="Handle Ring" transform="translate(100 47)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-50)" stroke-width="2">
      <circle cx="8" cy="8" r="8" stroke="none"/>
      <circle cx="8" cy="8" r="7" fill="none"/>
    </g>
    <g id="Handle_Border_Outside" data-name="Handle Border Outside" transform="translate(99 46)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.42" stroke-width="1">
      <circle cx="9" cy="9" r="9" stroke="none"/>
      <circle cx="9" cy="9" r="8.5" fill="none"/>
    </g>
    <circle id="Handle_Fill" data-name="Handle Fill" cx="6" cy="6" r="6" transform="translate(102 49)" fill="var(--anatomy-gray-400)"/>
    <g id="Handle_Border_Inside" data-name="Handle Border Inside" transform="translate(102 49)" fill="var(--anatomy-gray-800)" fill-opacity="0" stroke="var(--anatomy-gray-900)" stroke-opacity="0.42" stroke-width="1">
      <circle cx="6" cy="6" r="6" stroke="none"/>
      <circle cx="6" cy="6" r="5.5" fill="none"/>
    </g>
  </g>
</svg>
